// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"bb74cd17","96":"5bb08de9","358":"2341817d","404":"65dbbed4","570":"366c8782","641":"bc256bda"}[chunkId] + ".chunk.js";
};